import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Header from '../../components/ContentSelection/Header';
import AssetList from '../../components/AssetList';
import { actions as contentActions } from '../../actions/content';
import LuciPropTypes from '../../propTypes/';
import Pagination from '../../components/Pagination';
import { Container, StickyHeader } from '../../styled-components/Layout';

const PaginationOuterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-content: flex-end;
`;

const PaginationInnerContainer = styled.div`
  position: fixed;
  bottom: .5rem;
  right: 6rem;
  flex-direction: column;
`;

const ContentListContainer = styled(Container)`;
  flex-direction: row;
`;

class ClipperMovieSelection extends PureComponent {
  UNSAFE_componentWillMount() {
    this.props.loadContent('video');
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const userLoggedIn = nextProps.authenticated;
    const categoriesPopulated = nextProps.categoryList && nextProps.categoryList.length > 0;
    const contextsPopulated = nextProps.contextList && nextProps.contextList.length > 0;
    const optionsInitialized = contextsPopulated && categoriesPopulated;
    const contentNeedUpdate = nextProps.needUpdate;
    const contentLoading = nextProps.contentLoading;

    if (userLoggedIn && optionsInitialized && !contentLoading) {
      Object.keys(nextProps.content).forEach((key) => {
        if (nextProps.content[key].needUpdate || contentNeedUpdate) {
          this.props.getContent('video', nextProps.content[key].searchType);
        }
      });
    }
  }

  render() {
    const { content,
      toggleFavorite,
      onConfirmAssetSelected,
      changePage,
      contentRequestQueued,
      reload,
      shortcuts } = this.props;

    return (
      <Container>
        <StickyHeader>
          <Header />
        </StickyHeader>
        <ContentListContainer>
          <AssetList
            assetList={content.localcontent.contentList}
            toggleFavorite={(id, favorite) => toggleFavorite(id, favorite, 'localcontent')}
            loading={contentRequestQueued || content.localcontent.loading}
            onDoubleClick={(res) => { onConfirmAssetSelected(res); }}
            error={content.localcontent.error}
            reload={reload}
          />
          <PaginationOuterContainer>
            <PaginationInnerContainer>
              <Pagination
                nextPageShortcut={shortcuts.nextPage}
                prevPageShortcut={shortcuts.prevPage}
                totalPages={content.localcontent.totalPages}
                currentPage={content.localcontent.pageNumber}
                buffer={1}
                onChange={(newPage) => changePage(newPage, 'localcontent')}
              />
            </PaginationInnerContainer>
          </PaginationOuterContainer>
        </ContentListContainer>
      </Container>
    );
  }
}

ClipperMovieSelection.defaultProps = {
  onConfirmAssetSelected: () => { }
};

ClipperMovieSelection.propTypes = {
  content: LuciPropTypes.Content.isRequired,
  toggleFavorite: PropTypes.func.isRequired,
  getContent: PropTypes.func.isRequired,
  loadContent: PropTypes.func.isRequired,
  onConfirmAssetSelected: PropTypes.func,
  changePage: PropTypes.func.isRequired,
  contentRequestQueued: PropTypes.bool.isRequired,
  reload: PropTypes.func.isRequired,
  shortcuts: PropTypes.shape({
    nextPage: PropTypes.arrayOf(PropTypes.string),
    prevPage: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
};

const mapStateToProps = (state) => ({
  content: state.content.contentList,
  userId: state.auth.user.userId,
  axisTrackEnabled: state.auth.axisUserProfile.services.includes('Track'), // ToDo: CHANGE THIS!!!  Use id instead when it's implemented axis side
  authenticated: state.auth.authenticated,
  contentRequestQueued: state.content.contentRequestQueued,
  needUpdate: state.content.needUpdate,
  contextList: state.content.contextList,
  categoryList: state.content.categoryList,
  shortcuts: state.keyShortcuts.shortcuts
});

const mapActionCreators = {
  toggleFavorite: contentActions.toggleFavorite,
  getContent: contentActions.getContent,
  loadContent: contentActions.loadContent,
  changePage: contentActions.changePage,
  reload: contentActions.reload
};

export default connect(mapStateToProps, mapActionCreators)(ClipperMovieSelection);



// WEBPACK FOOTER //
// ./app/components/Clipper/ClipperMovieSelection.js